import { ICommonDataLayerEventNamesType, ICommonDataLayerOptions } from "../types/ITagGa4.interface";

const useTaggingGa4 = () => {
  const handlePush = (dataLayer) => {
    if (!window || typeof window === 'undefined') return;

    window['dataLayer'] = window['dataLayer'] || []
    window['dataLayer'].push(dataLayer)
  }

  const pushCommonDataLayer = (
    eventName: ICommonDataLayerEventNamesType,
    options?: ICommonDataLayerOptions
  ) => {
    const sendData = {
      event: eventName,
      ...options
    }

    handlePush(sendData)
  }


  return {
    pushCommonDataLayer
  }
};

export default useTaggingGa4;